export default __webpack_public_path__ + "static/crescat-6a3da16163c2b624c5f9b990a74a1124.svg";